// Copied verbatim from the desktop app so the two look identical.
// Do not edit here: change the app's copy, then run
//   node scripts/sync-app-components.mjs --write
// `pnpm verify:components` fails the build if the two drift apart.
import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("animate-pulse rounded-md bg-accent", className)}
      {...props}
    />
  );
}

export { Skeleton };
